export default "__VITE_ASSET__Bof47tHg__"